import React, { Component, Fragment } from 'react'
import Autocomplete from './Autocomplete'
import styled, { css } from 'styled-components'
import FICColors from 'FICColors'
import FICLink from 'FICLink'
import { FALIcon } from 'FAIcon'

export default class BreadCrumbs extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  handleOpen = (value) => {
    this.setState({ shadow: value })
  }

  render () {
    return (
      <BreadCrumbsImp shadow={this.state.shadow} className={this.props.className}>
        <div className={`breadCrumbsContainer ${this.props.embedded ? 'embeddedbreadCrumbs' : ''}`}>
          <BreadCrumbsText>
            <FICLink text='Supporto clienti' onClick={() => this.props.onSelect(undefined, 'main')} />
            <FALIcon name='angle-right' />
            {this.props.paths.map((path, idx) => {
              return (
                <Fragment key={idx}>
                  {path.onClick
                    ? <FICLink text={path.text} onClick={() => path.onClick()} />
                    : <span style={{ fontWeight: 600 }}>{path.text}</span>
                  }
                  {idx < this.props.paths.length - 1 &&
                  <FALIcon name='angle-right' />
                  }
                </Fragment>
              )
            })}
          </BreadCrumbsText>
          <Autocomplete
            internal
            onSelect={this.props.onSelect}
            onOpen={this.handleOpen}
            className='autocomplete'
            realm={this.props.realm}
          />
        </div>
      </BreadCrumbsImp>
    )
  }
}

const BreadCrumbsImp = styled.div`
	height: 64px;
	width: 100%;
	box-sizing: border-box;
	background-color: ${FICColors.white};
	border-bottom:1px solid rgba(51,51,51,0.08);
	position: relative;
	color:${FICColors.textDefault};
	font-size: 16px;
	z-index: 100;
	@media (max-width: 425px) {
	  font-size: 14px;
	}
	${props => props.shadow && css`
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);
  `}
	.breadCrumbsContainer{
	  max-width: 940px;
	  margin: 0 auto;
	  position: relative;
    ${props => props.embedded && css`
      max-width: 800px;
    `}
	}
  .embeddedbreadCrumbs {
    max-width: 800px;
  }
	.FICLink{
	  display: inline-block;
	  padding: 20px 0;
	  @media (max-width: 425px) {
	    padding: 17px 0;
	  }
    a{
      color: ${FICColors.defaultBlue};
      line-height: 24px;
      text-decoration: underline;
    }
  }
  .faicon{
    margin: 0 8px;
    color: ${FICColors.textDefault};
    font-size: 14px;
  }
  .internalAutocomplete{
    float: right;
    width: 50px;    
    margin: 0;
    max-height: 100%;
    box-sizing: border-box;
    box-shadow: none;
    .faicon{
      font-size: 24px;
      color: #333;
    }
    input{height: 100%}
  }
`
const BreadCrumbsText = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  @media (max-width: 425px) {
    width: calc(100% - 50px);
  }
`



// WEBPACK FOOTER //
// ./src/help/common/BreadCrumbs.js